import React, { useState } from "react";
import { FaCrown } from "react-icons/fa6";
import defaultProfilePic from "../../../assets/images/anonymous.jpg.webp"

const IMAGE_BASE = process.env.REACT_APP_BASE_URL_IMAGE;

const TraderCard = ({traders}) => {
  const [activeTab, setActiveTab] = useState("all");
  return (
    <section className="px-6 pb-4 mt-2">
      {/* <div className="flex items-center justify-between mb-6">
                <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-gradient-to-r text-white from-yellow-400 to-orange-500 rounded-lg flex items-center justify-center">
                        <FaTrophy/>
                    </div>
                    <h2 className="text-xl font-bold text-dark">Top Traders</h2>
                </div>
                <button className="text-[#7c90e9] font-semibold text-sm hover:text-[#6B7FE5] transition-colors">
                    View All
                </button>
            </div> */}

      <div
        id="signals-filter-tabs"
        className="bg-white p-1 rounded-xl flex gap-2 items-center justify-around mb-8 shadow-sm"
      >
        {/* دکمه اول */}
        <button
          onClick={() => setActiveTab("week")}
          className={`w-full text-center py-2 rounded-xl font-semibold transition-all duration-300 ${
            activeTab === "week"
              ? "bg-gradient-to-r from-[#7c90e9] to-[#8B9FEB] text-white shadow-md"
              : "text-slate-600 hover:bg-slate-50"
          }`}
        >
          Last Week
        </button>

        {/* دکمه دوم */}
        <button
          onClick={() => setActiveTab("all")}
          className={`w-full text-center py-2 rounded-xl font-semibold transition-all duration-300 ${
            activeTab === "all"
              ? "bg-gradient-to-r from-[#7c90e9] to-[#8B9FEB] text-white shadow-md"
              : "text-slate-600 hover:bg-slate-50"
          }`}
        >
          All Time
        </button>
      </div>

      {/* Olympic Podium Style for Top 3 */}
      <div className="relative mb-8 px-4">
        <div className="flex items-end justify-center space-x-2">
          {/* 2nd Place */}
          <div className="flex flex-col items-center">
            <div className="relative mb-3">
              <img
                  src={traders?.[1]?.imageId?.path ? IMAGE_BASE + traders?.[1]?.imageId?.path : defaultProfilePic}
                alt="User"
                className="w-16 h-16 rounded-2xl object-cover border-4 border-gray-400"
              />
              <div className="absolute -top-3 -right-1 w-8 h-8 bg-gradient-to-r from-gray-400 to-gray-600 rounded-full flex items-center justify-center shadow-lg">
                <span className="text-white text-sm font-bold">2</span>
              </div>
            </div>
            <div className="bg-gradient-to-t from-gray-300 to-gray-400 w-20 h-16 rounded-t-xl flex items-end justify-center pb-2">
              <span className="text-white font-bold text-xs">2nd</span>
            </div>
            <div className="text-center mt-2">
              <p className="font-bold text-sm">{traders?.[1]?.fullName ? traders[1].fullName : "No Name"}</p>
              {/*<p className="text-xs text-green-600 font-semibold">+987%</p>*/}
            </div>
          </div>

          {/* 1st Place */}
          <div className="flex flex-col items-center">
            <div className="relative mb-3">
              <img
                  src={traders?.[0]?.imageId?.path ? IMAGE_BASE + traders?.[0]?.imageId?.path : defaultProfilePic}
                alt="User"
                className="w-20 h-20 rounded-2xl object-cover border-4 border-yellow-400"
              />
              <div className="absolute text-white -top-4 -right-2 w-10 h-10 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full flex items-center justify-center shadow-lg">
                <FaCrown className="w-6 h-5" />
              </div>
            </div>
            <div className="bg-gradient-to-t from-yellow-400 to-yellow-500 w-24 h-20 rounded-t-xl flex items-end justify-center pb-2">
              <span className="text-white font-bold text-sm">1st</span>
            </div>
            <div className="text-center mt-2">
                <p className="font-bold text-sm">{traders?.[0]?.fullName ? traders[0].fullName : "No Name"}</p>
              {/*<p className="text-sm text-green-600 font-semibold">+1,247%</p>*/}
            </div>
          </div>

          {/* 3rd Place */}
          <div className="flex flex-col items-center">
            <div className="relative mb-3">
              <img
                  src={traders?.[2]?.imageId?.path ? IMAGE_BASE + traders?.[2]?.imageId?.path : defaultProfilePic}
                alt="User"
                className="w-16 h-16 rounded-2xl object-cover border-4 border-amber-500"
              />
              <div className="absolute -top-3 -right-1 w-8 h-8 bg-gradient-to-r from-amber-400 to-orange-600 rounded-full flex items-center justify-center shadow-lg">
                <span className="text-white text-sm font-bold">3</span>
              </div>
            </div>
            <div className="bg-gradient-to-t from-amber-400 to-amber-500 w-20 h-12 rounded-t-xl flex items-end justify-center pb-2">
              <span className="text-white font-bold text-xs">3rd</span>
            </div>
            <div className="text-center mt-2">
                <p className="font-bold text-sm">{traders?.[2]?.fullName ? traders[2].fullName : "No Name"}</p>
              {/*<p className="text-xs text-green-600 font-semibold">+856%</p>*/}
            </div>
          </div>
        </div>
      </div>

      {/* List for 4th and beyond */}
      <div className="space-y-3">
        {/* Trader 4 */}
        <div className="bg-white rounded-xl shadow-md border border-gray-100 p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full">
                <span className="text-gray-600 font-bold text-sm">4</span>
              </div>
              <img
                  src={traders?.[3]?.imageId?.path ? IMAGE_BASE + traders?.[3]?.imageId?.path : defaultProfilePic}
                alt="Trader"
                className="w-12 h-12 rounded-xl object-cover"
              />
              <div>
                <h3 className="font-semibold text-dark">{traders?.[3]?.fullName ? traders[3].fullName : "No Name"}</h3>
                {/*<p className="text-gray-500 text-xs">156 Signals</p>*/}
              </div>
            </div>
            {/*<div className="text-right">*/}
            {/*  <p className="text-lg font-bold text-green-600">+654%</p>*/}
            {/*  <p className="text-gray-500 text-xs">Monthly Return</p>*/}
            {/*</div>*/}
          </div>
        </div>

        {/* Trader 5 */}
        <div className="bg-white rounded-xl shadow-md border border-gray-100 p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full">
                <span className="text-gray-600 font-bold text-sm">5</span>
              </div>
              <img
                  src={traders?.[4]?.imageId?.path ? IMAGE_BASE + traders?.[4]?.imageId?.path : defaultProfilePic}
                alt="Trader"
                className="w-12 h-12 rounded-xl object-cover"
              />
              <div>
                <h3 className="font-semibold text-dark">M{traders?.[4]?.fullName ? traders[4].fullName : "No Name"}</h3>
                {/*<p className="text-gray-500 text-xs">142 Signals</p>*/}
              </div>
            </div>
            {/*<div className="text-right">*/}
            {/*  <p className="text-lg font-bold text-green-600">+543%</p>*/}
            {/*  <p className="text-gray-500 text-xs">Monthly Return</p>*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TraderCard;

// import Anonymous from '../image/anonymous.jpg.webp'
// import prof1 from '../image/test.jpg'
// export default function TraderCard({data}){
//     return(
//     <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-4 flex items-center justify-between">
//             <div className="flex items-center">
//                 <div className="relative">
//                 <img src={prof1} className="w-12 h-12 rounded-full"></img>
//                     <div className="absolute -top-2 -right-2 bg-gray-400 text-white text-xs w-6 h-6 rounded-full flex items-center justify-center font-bold">2</div>
//                 </div>
//                 <div className="ml-4">
//                     <h4 className="font-bold text-dark">Sara Ahmadi</h4>
//                     <p className="text-xs text-secondary">Success Rate: 89%</p>
//                     <div className="flex items-center mt-1">
//                         <span className="bg-blue-100 text-blue-600 text-xs px-2 py-1 rounded-full font-semibold">FREE</span>
//                         <span className="ml-2 text-xs text-secondary">180 Signals</span>
//                     </div>
//                 </div>
//             </div>
//
//             <div className="text-right">
//                 <p className="text-green-600 font-bold text-lg">+987%</p>
//                 <p className="text-xs text-secondary">Monthly Profit</p>
//                 <button className="bg-primary text-white px-4 py-2 rounded-lg text-xs font-semibold mt-2 hover:shadow-lg transition">
//                     Follow
//                 </button>
//             </div>
//     </div>
//     )
// }
